module.exports = __webpack_public_path__ + "img/selected5-min.45a6a303.png";